var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Video")]),
    _vm._v(" "),
    _c("div", { staticClass: "row my-3" }, [
      _c("div", { staticClass: "col-6" }, [
        _c("div", { staticClass: "fields-wrapper" }, [
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "vidname" }
              },
              [_vm._v("Video Selector")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.objectDbHash,
                      expression: "inputData.objectDbHash"
                    }
                  ],
                  staticClass: "custom-select",
                  attrs: { placeholder: "Video Selector", id: "vidname" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.inputData,
                          "objectDbHash",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function($event) {
                        return _vm.changeSelectedModel($event)
                      }
                    ]
                  }
                },
                _vm._l(_vm.getVideos, function(model, key) {
                  return _c("option", { key: key, domProps: { value: key } }, [
                    _vm._v(_vm._s(model.name))
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v(" Display Type ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.displayType,
                      expression: "inputData.displayType"
                    }
                  ],
                  staticClass: "custom-select",
                  attrs: { placeholder: "Select Media Type" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.inputData,
                        "displayType",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "Screen" } }, [
                    _vm._v("Screen")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "Scene" } }, [_vm._v("Scene")])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "start_time" }
              },
              [_vm._v("\n            Start Time\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputData.startTime,
                    expression: "inputData.startTime"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", id: "start_time" },
                domProps: { value: _vm.inputData.startTime },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.inputData, "startTime", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "end_time" }
              },
              [_vm._v("\n            End Time\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputData.endTime,
                    expression: "inputData.endTime"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", id: "end_time" },
                domProps: { value: _vm.inputData.endTime },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.inputData, "endTime", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "video_duration_e" }
              },
              [_vm._v("\n            Duration\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputData.presenceDuration,
                    expression: "inputData.presenceDuration"
                  }
                ],
                staticClass: "form-control",
                class: {
                  "border-danger":
                    (
                      parseFloat(_vm.inputData.endTime) -
                      parseFloat(_vm.inputData.startTime)
                    ).toFixed(2) <= 0
                },
                attrs: { type: "text", disabled: "", id: "video_duration_e" },
                domProps: { value: _vm.inputData.presenceDuration },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.inputData,
                      "presenceDuration",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("\n              Volume\n            ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputData.videoSettings.volumeVideo,
                    expression: "inputData.videoSettings.volumeVideo"
                  }
                ],
                attrs: { type: "range", min: "0", max: "1", step: "0.1" },
                domProps: { value: _vm.inputData.videoSettings.volumeVideo },
                on: {
                  __r: function($event) {
                    return _vm.$set(
                      _vm.inputData.videoSettings,
                      "volumeVideo",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2" }, [
                _vm._v(_vm._s(_vm.inputData.videoSettings.volumeVideo))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("\n            Loop\n          ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("div", { staticClass: "input-switch label-right p-0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputData.videoSettings.videoLoop,
                        expression: "inputData.videoSettings.videoLoop"
                      }
                    ],
                    attrs: { type: "checkbox", id: "loop" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.inputData.videoSettings.videoLoop
                      )
                        ? _vm._i(_vm.inputData.videoSettings.videoLoop, null) >
                          -1
                        : _vm.inputData.videoSettings.videoLoop
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.inputData.videoSettings.videoLoop,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.inputData.videoSettings,
                                "videoLoop",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.inputData.videoSettings,
                                "videoLoop",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.inputData.videoSettings,
                            "videoLoop",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c("div", { staticClass: "fields-wrapper" }, [
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("\n              Scale\n            ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputData.scale,
                    expression: "inputData.scale"
                  }
                ],
                attrs: { type: "range", min: "0", max: "1", step: "0.1" },
                domProps: { value: _vm.inputData.scale },
                on: {
                  __r: function($event) {
                    return _vm.$set(_vm.inputData, "scale", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2" }, [
                _vm._v(_vm._s(_vm.inputData.scale))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("\n              Layer\n            ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group dropright col-sm-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light dropdown-toggle",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [_vm._v("\n                Select an action\n              ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    class:
                      _vm.inputData.layer >= _vm.layerStep
                        ? "disabled action-disabled"
                        : "",
                    on: {
                      click: function($event) {
                        return _vm.bringToFront()
                      }
                    }
                  },
                  [_vm._v("Bring to front")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    class:
                      _vm.inputData.layer >= _vm.layerStep
                        ? "disabled action-disabled"
                        : "",
                    on: {
                      click: function($event) {
                        return _vm.changeLayer(1)
                      }
                    }
                  },
                  [_vm._v("Bring forward")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    class:
                      _vm.inputData.layer <= -_vm.layerStep
                        ? "disabled action-disabled"
                        : "",
                    on: {
                      click: function($event) {
                        return _vm.changeLayer(-1)
                      }
                    }
                  },
                  [_vm._v("Send backward")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    class:
                      _vm.inputData.layer <= -_vm.layerStep
                        ? "disabled action-disabled"
                        : "",
                    on: {
                      click: function($event) {
                        return _vm.sendToBack()
                      }
                    }
                  },
                  [_vm._v("Send to back")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.inputData.displayType == "Scene"
            ? _c("div", { staticClass: "row form-group align-items-center" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-sm-4 col-form-label",
                    attrs: { for: "minimum_distance" }
                  },
                  [_vm._v("\n            Minimum Distance\n          ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-8" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputData.minimumDistance,
                        expression: "inputData.minimumDistance"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", id: "minimum_distance" },
                    domProps: { value: _vm.inputData.minimumDistance },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.inputData,
                          "minimumDistance",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.inputData.displayType == "Scene"
            ? _c("div", { staticClass: "row form-group align-items-center" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-sm-4 col-form-label",
                    attrs: { for: "maximum_distance" }
                  },
                  [_vm._v("\n            Maximum Distance\n          ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-8" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputData.maximumDistance,
                        expression: "inputData.maximumDistance"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", id: "maximum_distance" },
                    domProps: { value: _vm.inputData.maximumDistance },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.inputData,
                          "maximumDistance",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.inputData.displayType === "Screen"
            ? _c(
                "div",
                { staticClass: "row form-group align-items-center py-3" },
                [
                  _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                    _vm._v("\n            Alignment\n          ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-8 align-items-center" },
                    [
                      _c("Icon", {
                        staticClass: "cursor-pointer mr-1",
                        attrs: {
                          icon: "align_left",
                          color:
                            _vm.inputData.objectTransformSimple.horizontal ==
                            "left"
                              ? "Dodgerblue"
                              : "white"
                        },
                        on: {
                          click: function($event) {
                            return _vm.horizontalAlignment("left")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("Icon", {
                        staticClass: "cursor-pointer mr-1",
                        attrs: {
                          icon: "align_center",
                          color:
                            _vm.inputData.objectTransformSimple.horizontal ==
                            "center"
                              ? "Dodgerblue"
                              : "white"
                        },
                        on: {
                          click: function($event) {
                            return _vm.horizontalAlignment("center")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("Icon", {
                        staticClass: "cursor-pointer mr-4",
                        attrs: {
                          icon: "align_right",
                          color:
                            _vm.inputData.objectTransformSimple.horizontal ==
                            "right"
                              ? "Dodgerblue"
                              : "white"
                        },
                        on: {
                          click: function($event) {
                            return _vm.horizontalAlignment("right")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("Icon", {
                        staticClass: "cursor-pointer mr-1",
                        attrs: {
                          icon: "align_bottom",
                          color:
                            _vm.inputData.objectTransformSimple.vertical ==
                            "bottom"
                              ? "Dodgerblue"
                              : "white"
                        },
                        on: {
                          click: function($event) {
                            return _vm.verticalAlignment("bottom")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("Icon", {
                        staticClass: "cursor-pointer mr-1",
                        attrs: {
                          icon: "align_middle",
                          color:
                            _vm.inputData.objectTransformSimple.vertical ==
                            "center"
                              ? "Dodgerblue"
                              : "white"
                        },
                        on: {
                          click: function($event) {
                            return _vm.verticalAlignment("center")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("Icon", {
                        staticClass: "cursor-pointer mr-1",
                        attrs: {
                          icon: "align_top",
                          color:
                            _vm.inputData.objectTransformSimple.vertical ==
                            "top"
                              ? "Dodgerblue"
                              : "white"
                        },
                        on: {
                          click: function($event) {
                            return _vm.verticalAlignment("top")
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.inputData.displayType == "Screen"
            ? _c("div", { staticClass: "row form-group align-items-center" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-sm-4 col-form-label",
                    attrs: { for: "offset_horizontal" }
                  },
                  [_vm._v("\n            Offset Horizontal\n          ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-8" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.inputData.objectTransformSimple.offsetHorizontal,
                        expression:
                          "inputData.objectTransformSimple.offsetHorizontal"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", id: "offset_horizontal" },
                    domProps: {
                      value:
                        _vm.inputData.objectTransformSimple.offsetHorizontal
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.inputData.objectTransformSimple,
                          "offsetHorizontal",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.inputData.displayType == "Screen"
            ? _c("div", { staticClass: "row form-group align-items-center" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-sm-4 col-form-label",
                    attrs: { for: "offset_vertical" }
                  },
                  [_vm._v("\n            Offset Vertical\n          ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-8" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.inputData.objectTransformSimple.offsetVertical,
                        expression:
                          "inputData.objectTransformSimple.offsetVertical"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", id: "offset_vertical" },
                    domProps: {
                      value: _vm.inputData.objectTransformSimple.offsetVertical
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.inputData.objectTransformSimple,
                          "offsetVertical",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.inputData.displayType == "Scene"
            ? _c("div", { staticClass: "row form-group align-items-center" }, [
                _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                  _vm._v("\n            Position of the Origin\n          ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-8" }, [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputData.positionOfOrigin[0],
                          expression: "inputData.positionOfOrigin[0]"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "position_of_the_origin_x" },
                      domProps: { value: _vm.inputData.positionOfOrigin[0] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.inputData.positionOfOrigin,
                            0,
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputData.positionOfOrigin[1],
                          expression: "inputData.positionOfOrigin[1]"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "position_of_the_origin_y" },
                      domProps: { value: _vm.inputData.positionOfOrigin[1] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.inputData.positionOfOrigin,
                            1,
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputData.positionOfOrigin[2],
                          expression: "inputData.positionOfOrigin[2]"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "position_of_the_origin_z" },
                      domProps: { value: _vm.inputData.positionOfOrigin[2] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.inputData.positionOfOrigin,
                            2,
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.inputData.displayType == "Scene"
            ? _c("div", { staticClass: "row form-group align-items-center" }, [
                _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                  _vm._v("\n            Rotation of the Origin\n          ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-8" }, [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputData.rotationOfOrigin[0],
                          expression: "inputData.rotationOfOrigin[0]"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number", id: "rotation_of_the_origin_x" },
                      domProps: { value: _vm.inputData.rotationOfOrigin[0] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.inputData.rotationOfOrigin,
                            0,
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputData.rotationOfOrigin[1],
                          expression: "inputData.rotationOfOrigin[1]"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number", id: "rotation_of_the_origin_y" },
                      domProps: { value: _vm.inputData.rotationOfOrigin[1] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.inputData.rotationOfOrigin,
                            1,
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputData.rotationOfOrigin[2],
                          expression: "inputData.rotationOfOrigin[2]"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number", id: "rotation_of_the_origin_z" },
                      domProps: { value: _vm.inputData.rotationOfOrigin[2] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.inputData.rotationOfOrigin,
                            2,
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "label-left", attrs: { for: "loop" } }, [
      _c("span")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-740f3911", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-740f3911","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/media-videos/maininspector.vue
// module id = null
// module chunks = 